import { css } from "@emotion/react";

export const ButtonReset = css`
    all: unset;
    display: inline-block;
    box-sizing: border-box;
    cursor: pointer;
`;

export const splitButtonMixin = css`
    appearance: none;
    padding: ${10 / 16}rem ${12 / 16}rem;
    display: flex;
    align-items: center;
    padding: ${10 / 16}rem ${12 / 16}rem;
`;
